import I18n from 'I18n';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UISelect from 'UIComponents/input/UISelect';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorRollingWithUnitInput = props => {
  const {
    condition,
    error,
    inputUse,
    onChange,
    onBlur
  } = props;

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'direction' implicitly has an 'any... Remove this comment to see the full error message
  const handleChangeDirection = ({
    target: {
      value: direction
    }
  }) => onChange(syntheticEvent(condition.set('direction', direction)));

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'time' implicitly has an 'any' typ... Remove this comment to see the full error message
  const handleChangeValue = ({
    target: {
      value: time
    }
  }) => onChange(syntheticEvent(condition.merge({
    direction: condition.direction || 'backward',
    value: time,
    timeUnit: condition.timeUnit || 'days'
  })));

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'timeUnit' implicitly has an 'any'... Remove this comment to see the full error message
  const handleChangeTimeUnit = ({
    target: {
      value: timeUnit
    }
  }) => onChange(syntheticEvent(condition.set('timeUnit', timeUnit)));
  const directionOptions = [{
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditorOperatorRollingUnitInput.directionOptionLabelBackward'),
    value: 'backward'
  }, {
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditorOperatorRollingUnitInput.directionOptionLabelForward'),
    value: 'forward'
  }];
  const unitOptions = [{
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditorOperatorRollingUnitInput.days'),
    value: 'days'
  }, {
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditorOperatorRollingUnitInput.weeks'),
    value: 'weeks'
  }];
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "baseline",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
        error: error.error,
        validationMessage: error.error ? error.message : null,
        children: /*#__PURE__*/_jsx(UINumberInput, {
          defaultValue: 1,
          min: 1,
          onBlur: onBlur
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          ,
          onChange: handleChangeValue,
          use: inputUse,
          value: condition.value
        })
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      buttonUse: "unstyled",
      className: "m-left-2",
      defaultValue: "days",
      onChange: handleChangeTimeUnit,
      options: unitOptions,
      value: condition.timeUnit
    }), /*#__PURE__*/_jsx(UISelect, {
      buttonUse: "unstyled",
      className: "m-left-2",
      defaultValue: "backward",
      onChange: handleChangeDirection,
      options: directionOptions,
      value: condition.direction
    })]
  });
};
export default FilterOperatorRollingWithUnitInput;